import { render, staticRenderFns } from "./ContratoDashboard.vue?vue&type=template&id=7b8b0534&scoped=true"
import script from "./ContratoDashboard.vue?vue&type=script&lang=js"
export * from "./ContratoDashboard.vue?vue&type=script&lang=js"
import style0 from "./ContratoDashboard.vue?vue&type=style&index=0&id=7b8b0534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b0534",
  null
  
)

export default component.exports